import supabase from '../supabase/supabase';

export const dashboardService = {
  async getClientDashboardScope(organizationId) {
    if (!organizationId) {
      throw new Error('Select a client before loading dashboard data.');
    }

    const { data, error } = await supabase.rpc(
      'get_owner_client_dashboard_scope_v2',
      { p_organization_id: organizationId }
    );

    if (error) throw error;

    const scope = Array.isArray(data) ? data[0] : data;

    if (!scope?.organization_id) {
      throw new Error(
        'This client is not available under the current Owner organization.'
      );
    }

    return scope;
  }
};